import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './App.css';
import Header from './Header';
import Footer from './Footer';
import { setCanonicalURL, setPageTitle, setMetaDescription, setAlternateTags, pageSEO } from './utils/seo';

// SEO Handler Component
function SEOHandler() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    let seoData;
    let canonicalPath = path;

    // Determine SEO data based on route
    if (path === '/') {
      seoData = pageSEO.home;
      canonicalPath = '/';
    } else if (path.startsWith('/products/')) {
      // Dynamic product detail page - use the exact path for canonical
      seoData = pageSEO.products;
      canonicalPath = path; // Keep full path for product detail pages
    } else if (path === '/products') {
      seoData = pageSEO.products;
      canonicalPath = '/products';
    } else if (path === '/about') {
      seoData = pageSEO.about;
      canonicalPath = '/about';
    } else if (path === '/contact') {
      seoData = pageSEO.contact;
      canonicalPath = '/contact';
    } else if (path === '/testimonials') {
      seoData = pageSEO.testimonials;
      canonicalPath = '/testimonials';
    } else if (path.startsWith('/customer-order/') || path.startsWith('/order/') || path.startsWith('/invoice/')) {
      // Dynamic order/invoice pages - use exact path
      canonicalPath = path;
      seoData = {
        title: 'Order Details - MMK Industries',
        description: 'View your order details and status',
        canonical: canonicalPath
      };
    } else if (path === '/check-order-status' || path === '/checkout' || path === '/cart' || path === '/order-success') {
      // Other pages that should be indexed
      canonicalPath = path;
      seoData = {
        title: 'MMK Industries Sdn Bhd - Welding Machines and Hardware Supplier',
        description: 'MMK Industries - Your trusted partner for welding machines and hardware supplies',
        canonical: canonicalPath
      };
    } else {
      // Default to home for unknown routes
      seoData = pageSEO.home;
      canonicalPath = '/';
    }

    // Set SEO data
    setPageTitle(seoData.title);
    setMetaDescription(seoData.description);
    setCanonicalURL(canonicalPath);
    // Set alternate language tags
    setAlternateTags(canonicalPath);
  }, [location]);

  return null;
}

function App({ children }) {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <SEOHandler />
      <Header />
      <main className="pt-20">
        {children}
      </main>
      <Footer />
    </div>
  );
}

export default App;
